export default "__VITE_ASSET__DFNXQffN__"